import { RailsApiWrapper } from '@sofatutor/common';

const functionPlaygroundRailsApiConfig = {
  baseURL: (import.meta as any).env?.VITE_RAILS_API_BASE_URL || '',
  apiTokenKey: (import.meta as any).env?.VITE_RAILS_API_TOKEN || '',
  endpoints: {
    generateOpenAiKey: '/api/ai_toolbox/v1/generate_open_ai_key'
  },
  apiRoutePatterns: ['/api/ai_toolbox/', '/api/ai_proxy/'],
  offlineMode: false
};

export default class FunctionPlaygroundApiWrapper extends RailsApiWrapper {
  constructor(config = functionPlaygroundRailsApiConfig) {
    super(config);
    // Ensure token/baseURL are applied at runtime
    const base = (import.meta as any).env?.VITE_RAILS_API_BASE_URL || '';
    if (base) {
      this.setBaseUrl(base);
    }
    const token = (import.meta as any).env?.VITE_RAILS_API_TOKEN || '';
    if (token) {
      this.setApiToken(token);
    }
  }
}


